import {useState} from 'react';

import {Button, Modal, Typography, useTheme} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

type ConfirmationModalProps = {
  title?: string;
  message: string;
  onClose: () => void;
  onAccept: () => void;
  challange?: string;
  variant: 'delete' | 'continue' | 'confirm';
};

function ConfirmationModal({title, message, onClose, onAccept, challange, variant}: ConfirmationModalProps) {
  const theme = useTheme();

  const [challangeText, setChallangeText] = useState<string>('');

  return (
    <>
      <Modal open={true} onClose={onClose}>
        <div className="top-2/4 left-2/4 w-[40%] h-fit p-3 absolute translate-x-[-50%] translate-y-[-50%] bg-background-default select-none">
          <div className="flex flex-col justify-center items-center gap-1 p-2">
            <Typography className="text-center" color={theme.palette.primary.contrastText} variant="h4">
              {title ?? 'Confirm action'}
            </Typography>

            <Typography className="pt-2" align="center" variant="body1">
              {message}
            </Typography>

            {challange && (
              <>
                <Typography className="pt-2" align="center" variant="body1">
                  To confirm, please type <span className="font-bold">{challange}</span> below
                </Typography>
                <input
                  className="w-[70%] mt-2 p-[15px] h-14 rounded outline-none text-white border-none bg-inputBox-backgroundColor"
                  value={challangeText}
                  placeholder={challange}
                  onChange={(e) => setChallangeText(e.target.value)}
                />
              </>
            )}

            <div className="flex flex-row justify-center mt-3 gap-4 items-center w-full">
              {variant === 'delete' ? (
                <Button
                  onClick={() => (challange ? !!challange && challange == challangeText && onAccept() : onAccept())}
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  disabled={!!challange && challange !== challangeText}
                  sx={{
                    '&.MuiButton-root': {
                      background: theme.palette.warning.dark,
                      color: theme.palette.text.main,
                    },
                    '&.Mui-disabled': {
                      background: theme.palette.card.dark,
                      color: theme.palette.text.disabled,
                    },
                  }}
                >
                  Delete
                </Button>
              ) : variant === 'continue' ? (
                <button
                  onClick={() => (challange ? !!challange && challange == challangeText && onAccept() : onAccept())}
                  disabled={!!challange && challange !== challangeText}
                  className="px-4 py-2 bg-blue-900 rounded-md text-lg hover:bg-blue-800 transition-all"
                >
                  CONTINUE
                </button>
              ) : (
                <Button
                  onClick={() => (challange ? !!challange && challange == challangeText && onAccept() : onAccept())}
                  variant="contained"
                  color="warning"
                  disabled={!!challange && challange !== challangeText}
                >
                  Confirm
                </Button>
              )}

              <Button
                variant="contained"
                onClick={onClose}
                sx={{
                  '&.MuiButton-root': {
                    background: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  },
                  '&.Mui-disabled': {
                    background: theme.palette.card.dark,
                    color: theme.palette.text.disabled,
                  },
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ConfirmationModal;
